import React from "react";
import "./spiral.css";

export default function Spiral() {
    return (
        <div className="spinner-container">
            <div className="spinner"></div>
        </div>
    );
}
